export const formSections = [
  {
    name: 'user',
    title: 'Your details',
    subTitle: 'This address is where the patient will mail their payment via cheque.',
    fields: [
      {
        name: 'name',
        label: 'Name on invoice',
        validations: {
          required: 'required',
          maxLength: { value: 120, message: 'max length of 120' },
        },
      },
      {
        name: 'address1',
        label: 'Street address 1',
        validations: {
          required: 'required',
          maxLength: { value: 25, message: 'max length of 25' },
        },
      },
      {
        name: 'address2',
        label: 'Street address 2',
        validations: { maxLength: { value: 25, message: 'max length of 25' } },
      },
      {
        name: 'city',
        label: 'City',
        validations: {
          required: 'required',
          maxLength: { value: 25, message: 'max length of 25' },
        },
      },
      {
        name: 'province',
        label: 'Province / state',
        validations: {
          required: 'required',
          maxLength: { value: 25, message: 'max length of 25' },
        },
      },
      {
        name: 'postalCode',
        label: 'Postal / zip code',
        validations: { required: 'required', maxLength: { value: 7, message: 'max length of 7' } },
      },
      {
        name: 'email',
        label: 'Email',
        validations: {
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: 'does not match email format. e.g. text@example.com',
          },
        },
      },
      {
        name: 'phone',
        label: 'Phone',
        validations: {
          required: 'required',
          pattern: {
            value: /(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}/,
            message: 'does not match phone number format. e.g. 311-555-5555',
          },
        },
      },
    ],
  },
  {
    name: 'patient',
    title: 'Patient details',
    fields: [
      { name: 'name', label: 'Patient name', validations: { required: 'required' } },
      {
        name: 'address1',
        label: 'Street address 1',
        validations: {
          required: 'required',
          maxLength: { value: 25, message: 'max length of 25' },
        },
      },
      {
        name: 'address2',
        label: 'Street address 2',
        validations: { maxLength: { value: 25, message: 'max length of 25' } },
      },
      {
        name: 'city',
        label: 'City',
        validations: {
          required: 'required',
          maxLength: { value: 25, message: 'max length of 25' },
        },
      },
      {
        name: 'province',
        label: 'Province / state',
        validations: {
          required: 'required',
          maxLength: { value: 25, message: 'max length of 25' },
        },
      },
      {
        name: 'postalCode',
        label: 'Postal / zip code',
        validations: { required: 'required', maxLength: { value: 7, message: 'max length of 7' } },
      },
      {
        name: 'country',
        label: 'Country',
        validations: {
          required: 'required',
          maxLength: { value: 25, message: 'max length of 25' },
        },
      },
    ],
  },
  {
    name: 'invoiceDetails',
    title: 'Invoice details',
    fields: [
      {
        name: 'number',
        label: 'Invoice number',
        helperText: 'Enter any number that makes sense for your records, e.g 001',
        validations: { required: 'required' },
      },

      {
        name: 'terms',
        label: 'Terms',
        helperText: 'Enter terms that make sense for your practice - 30, 60, 90 days, etc.',
        validations: { required: 'required' },
        multiLine: true,
      },
    ],
  },
]
